import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { FaTimes, FaFilePdf } from 'react-icons/fa';
import { formatarFechaLocal } from '../utils/fileUtils';
import './ConvocatoriaPopup.css';
const STORAGE_KEY = 'convocatoria-destacada-popup-seen';
const SHOW_AGAIN_AFTER_DAYS = 1;
const SEMANA_POPUP_FIN = '2026-02-20'; // Después de este día el popup vuelve a "una vez al día"

function getCierreDate(c) {
  if (!c || !c.fecha_fin) return null;
  return new Date(c.fecha_fin);
}

// Solo convocatorias destacadas que sigan vigentes (fecha de cierre >= hoy)
const hoyInicio = () => new Date(new Date().setHours(0, 0, 0, 0));

const ConvocatoriaPopup = ({ convocatorias = [] }) => {
  const [visible, setVisible] = useState(false);

  const convocatoriaDestacada = convocatorias.find((c) => {
    if (!c.destacada || !c.titulo) return false;
    const cierre = getCierreDate(c);
    if (!cierre) return true; // sin fecha de cierre se muestra
    return cierre >= hoyInicio();
  });

  useEffect(() => {
    if (!convocatoriaDestacada) return;
    const now = new Date();
    const finSemana = new Date(SEMANA_POPUP_FIN + 'T23:59:59');
    const dentroDeLaSemana = now <= finSemana;

    if (dentroDeLaSemana) {
      setVisible(true);
      return;
    }

    const lastSeen = localStorage.getItem(STORAGE_KEY);
    if (!lastSeen) {
      setVisible(true);
      return;
    }
    const lastDate = new Date(lastSeen);
    const daysSince = (now - lastDate) / (1000 * 60 * 60 * 24);
    if (daysSince >= SHOW_AGAIN_AFTER_DAYS) {
      setVisible(true);
    }
  }, [convocatoriaDestacada]);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setVisible(false);
  };

  if (!visible || !convocatoriaDestacada) return null;

  const overlay = (
    <div
      className="convocatoria-popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="convocatoria-popup-title"
      onClick={(e) => e.target === e.currentTarget && handleClose()}
    >
      <div className="convocatoria-popup" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="convocatoria-popup-close"
          onClick={handleClose}
          aria-label="Cerrar"
        >
          <FaTimes />
        </button>
        <div className="convocatoria-popup-content">
          <header className="convocatoria-popup-header">
            <p className="convocatoria-popup-entity">Diócesis de Ipiales</p>
            <p className="convocatoria-popup-tipo">Convocatoria Laboral</p>
            <p className="convocatoria-popup-cargo-label">Cargo</p>
            <h2 id="convocatoria-popup-title" className="convocatoria-popup-title">
              {convocatoriaDestacada.titulo}
            </h2>
          </header>
          {convocatoriaDestacada.fecha_fin && (
            <p className="convocatoria-popup-subtitle convocatoria-popup-cierre">
              Cierre: {formatarFechaLocal(convocatoriaDestacada.fecha_fin)}
            </p>
          )}
          <p className="convocatoria-popup-text">
            {(convocatoriaDestacada.descripcion || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 180)}…
          </p>
          <p className="convocatoria-popup-aviso-pdf">
            Postulación: formulario digital oficial. Lea los términos de referencia, complete el formulario y adjunte hoja de vida y documentación requerida.
          </p>
          <div className="convocatoria-popup-actions">
            <Link
              to={`/convocatorias/${convocatoriaDestacada.id}`}
              className="convocatoria-popup-btn-postular"
              onClick={handleClose}
            >
              <FaFilePdf /> Ver convocatoria y postular
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
};

export default ConvocatoriaPopup;
